export default __webpack_public_path__ + "static/media/partner-3.60e2edfa.png";